// extracted by mini-css-extract-plugin
module.exports = {"srOnly":"HeaderLink__srOnly--2TXYI","hiddenInput":"HeaderLink__hiddenInput--2pTd2","root":"HeaderLink__root--1PjND","active":"HeaderLink__active--3lxFa"};